import { render, staticRenderFns } from "./AccountLimitationsDataTableTab.vue?vue&type=template&id=35e27f25"
import script from "./AccountLimitationsDataTableTab.vue?vue&type=script&lang=js"
export * from "./AccountLimitationsDataTableTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports